import { makeStyles } from '@material-ui/styles'
import { ChevronRightRounded } from '@mui/icons-material'
import { Breadcrumbs, Button, Link, Stack, Typography } from '@mui/material'
import { blue, grey } from '@mui/material/colors'
import { BsFileEarmarkArrowUp } from 'react-icons/bs'
import { IoBagAddSharp } from 'react-icons/io5'
import Loading from 'react-loading'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../../store/store'


export default function Header({onNewShopBtnClick, onExportSalesBtnClick}:{onNewShopBtnClick: ()=>void, onExportSalesBtnClick:()=>void}) {

    const classes = useStyles()
    const currentBusinessName = useSelector((state:RootState)=>state?.currentBusiness?.metaData?.name)
    const totalShops_in_business = useSelector((state:RootState)=>state?.currentBusiness?.metaData?.total_shops)


    return(

        <Stack direction="row" justifyContent="space-between" alignItems="center" >
        
            <Stack direction="column">
                <Breadcrumbs sx={{color: grey[500] }} separator={<ChevronRightRounded />}  >
                    <Link className={classes.links} >
                        {
                            !currentBusinessName ? <Loading type='spin' color={grey[200]} height={18} width={18} /> : (
                                <Typography variant="h6" sx={{color: "grey.200", fontWeight: "bold" }}>{currentBusinessName}</Typography>
                            )
                        }
                    </Link>
                    <Link className={classes.link_current} >
                        Shops
                    </Link>
                </Breadcrumbs>
            </Stack>

            <Stack direction="row" spacing={2}>
                <Button 
                    onClick={onNewShopBtnClick} 
                    className={classes.button__newShop} 
                    variant="contained" 
                    title="Create new shop" 
                    startIcon={<IoBagAddSharp />}
                    disabled={currentBusinessName ? false : true}
                >
                    New Shop
                </Button>

                <Button 
                    onClick={onExportSalesBtnClick} 
                    className={classes.button__export}
                    disabled={totalShops_in_business! > 0 ? false : true}
                    variant="contained" 
                    title="Export shops" 
                    startIcon={<BsFileEarmarkArrowUp />} 
                >
                    Export
                </Button>
            </Stack>
        </Stack>

    )
}

const useStyles= makeStyles(theme=>({

    button__newShop:{
        color: grey[200],
        boxShadow: "none",
        backgroundColor: blue[700],
        textTransform: "capitalize",
        '&:hover': {
            backgroundColor: blue[700]
        },
        border: `.5px solid rgba(255, 255, 255, 0.1)`,
        '&:disabled':{
            backgroundColor: grey[500]
        },
    },
    button__export:{
        color: '#1A1B41',
        boxShadow: "none",
        backgroundColor: "#baff29",
        textTransform: "capitalize",
        '&:hover': {
            backgroundColor: '#baff29'
        },
        border: `.5px solid rgba(255, 255, 255, 0.1)`,
        '&:disabled':{
            backgroundColor: grey[500]
        },
    },
    links:{
        color: grey[200],
        textDecoration: "none",
        fontSize: "13px"
    },
    link_current:{
        color: grey[500],
        textDecoration: "none",
        fontSize: "13px"
    }

}))
